import React from "react";
import { useAuth } from "common/auth/Auth";
import { Box } from "common/components/Box";
import { ProgressBar } from "common/components/progression/ProgressBar";
import { H5 } from "common/components/Typography";
import { urls } from "common/urls";

interface Progression {
  text: string;
  progression?: {
    finishedContentIds?: string[];
    allContentIds?: string[];
  };
}

export const ContainerProgressionOverview: React.FC<Progression> = ({
  text,
  progression,
}) => {
  const auth = useAuth();
  return (
    <section style={{ marginTop: "1rem" }}>
      <Box kind="information" rounded={false} centeredContent={false}>
        <H5>{text}</H5>
        <ProgressBar progression={progression} backgroundColor="white" />
        {!auth.me?.principal?.user.hasGivenConsentForProgression && (
          <div style={{ marginTop: "1rem" }}>
            <i>
              NB: din progresjon lagres ikke siden du ikke har samtykket til
              det. Du kan endre dette på <a href={urls.profile}>din profil</a>.
            </i>
          </div>
        )}
      </Box>
    </section>
  );
};
